/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ weekday: NonNullable<unknown>, date: NonNullable<unknown> }} Today_Day_LabelInputs */

const en_us2_today_day_label = /** @type {(inputs: Today_Day_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weekday} ${i?.date}`)
};

const pt_br2_today_day_label = /** @type {(inputs: Today_Day_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weekday} ${i?.date}`)
};

const es_419_today_day_label = /** @type {(inputs: Today_Day_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weekday} ${i?.date}`)
};

const pt_pt2_today_day_label = /** @type {(inputs: Today_Day_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weekday} ${i?.date}`)
};

const fr_fr2_today_day_label = /** @type {(inputs: Today_Day_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weekday} ${i?.date}`)
};

const de_de2_today_day_label = /** @type {(inputs: Today_Day_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weekday} ${i?.date}`)
};

const it_it2_today_day_label = /** @type {(inputs: Today_Day_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weekday} ${i?.date}`)
};

/**
* | output |
* | --- |
* | "{weekday} {date}" |
*
* @param {Today_Day_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_day_label = /** @type {((inputs: Today_Day_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Day_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_day_label(inputs)
	if (locale === "es-419") return es_419_today_day_label(inputs)
	if (locale === "pt-PT") return pt_pt2_today_day_label(inputs)
	if (locale === "fr-FR") return fr_fr2_today_day_label(inputs)
	if (locale === "de-DE") return de_de2_today_day_label(inputs)
	if (locale === "it-IT") return it_it2_today_day_label(inputs)
	return en_us2_today_day_label(inputs)
});
export { today_day_label as "today.day_label" }